<template>
    <div class="detail">
        <div class="box_title">
            <div class="box_title_left">
                {{ name }}
            </div>
            <div class="box_title_right">
               <span class="el-icon-location-outline"></span> 当前位置:  <router-link to="/"> 首页 </router-link> /  {{ name }} 
            </div>
        </div>

        <div class="content_box">
            <div class="title">
                {{ info.volun_title }}
            </div>
            <div class="desc">
                <div class="from item">
                    {{ info.deptName }}
                </div>
                <div class="time item">
                    发布日期: {{ info.startTime }}
                </div>

                
            </div>
            <div class="detail news_content">
                <div class="img_box">
                    <img :src="info.headImg" v-if="info.headImg && info.headImg.indexOf('http') !== -1"  alt="">
                    <img :src="$ImgUrl + info.headImg" v-if="info.headImg && info.headImg.indexOf('http') == -1" alt="">
                    <img src="../../assets/static/index/default.png" v-if="!info.headImg" alt="">
                </div>
                <div class="info_box">
                    <div class="item type">
                        <span class="label">活动积分:</span>
                        <span class="value">{{ info.integral }}</span>
                    </div>
                    <div class="item time">
                        <span class="label">活动时间:</span>
                        <span class="value">{{ info.startTime }}</span>
                    </div>
                    <div class="item address">
                        <span class="label">活动地址:</span>
                        <span class="value">{{ info.meetingAddress }}</span>
                    </div>
                    <div class="item user">
                        <span class="label">报名上限:</span>
                        <span class="value">{{ info.count }}</span>
                    </div>
                    <!-- <div class="item users">
                        <span class="label">活动摘要:</span>
                        <span class="value">{{ info.startTime }}</span>
                    </div> -->
                    <div class="item request">
                        <span class="label">报名截止:</span>
                        <span class="value">{{ info.endTime }}</span>
                    </div>
                    <!-- <div class="item download">
                        <span class="label">会议附件:</span>
                        <span class="value">{{ info.startTime }}</span>
                    </div> -->
                    <div class="btn_box">
                        <!-- <div class="scan_box btn_item" @click="showerCode">
                            <span class="icons iconfont icon-saomaqiandao"></span>
                            <span class="txt">扫码签到</span>
                        </div> -->
                        <div class="qing_jia btn_item" @click="BaoMing">
                            <span class="icons iconfont icon-qingjia"></span>
                            <span class="txt">立即报名</span>
                        </div>
                    </div>
                </div>
            </div>

          

          

            <!-- 会议纪要 -->
            <div class="meeting_title">
                活动介绍
            </div>

            <div class="jiyao_box">
                <div class="jy_content" v-if="info.volun_content">
                    <div class="metting_content" v-html="info.volun_content"></div>                        
                </div>
            </div>

             <!-- 签到统计 -->
            <div class="meeting_title">
                报名统计
            </div>

            <div class="user_table">
                <el-table
                    :data="info.signSituation"
                    border
                    stripe
                    style="width: 100%">
                    <el-table-column
                    prop="id"
                    label="序号"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="name"
                    label="姓名"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="signTime"
                    align="center"
                    label="报名时间">
                    </el-table-column>
                </el-table>
            </div>
            
           



                <!-- 悬浮按钮 -->
                <div class="fixed_box">
                    <div class="item" v-for="(item, index) in iconList" 
                    :key="index" :class="active === index ? 'active': ''  "
                    @mouseover="MouseEnter( index )"
                    @mouseout="MouseOut"
                    @click="itemClick( index )"
                     >
                        <span :class="item.iconClass"></span>
                        <span class="txt" v-if="item.count">{{ item.count }}</span>
                    </div>
                    
                </div>

        </div>

    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                name: "活动详情",
                content: `<div>这里是文章内容</div>`,
                iconList: [
                    // { iconClass: "icon el-icon-star-off", count: 10 },
                    // { iconClass: "icon iconfont icon-dianzan", count: 10 },
                    { iconClass: "icon el-icon-share", count: 0 },
                    { iconClass: "icon el-icon-top", count: 0 },
                ],
                active: "",
                ruleForm: {
                    because: "",
                    img: ""
                },
                dialogImageUrl: '',
                dialogVisible: false,
                limit: 1,
                isQingJia: false,
                isSuccess: 0, // 请假状态  1成功 2失败
                info: {},
                codeShow: false, // 二维码是否展示
                codeUrl: "", // 二维码链接
            }
        },
        computed: {
            volun_id () {
                return Number( this.$route.params.id )
            },
            ...mapGetters(['token'])
        },
        created () {
            this.getMeetingDetail()
        },
        watch: {
            volun_id () {
                this.getMeetingDetail()
            }
        },
        mounted() {

        },
        methods: {
           
        //    报名
            async BaoMing() {
                let { token,volun_id } = this 
                if ( token ) {
                    let res = await this.$axios.post("/lencon/pc/activity/volun_sign", { token,  volun_id })
                    this.$message.info( res.data.msg )
                } else {
                    return this.$message.info("请登陆后在操作!")
                }
            },
            // 鼠标进入事件
            MouseEnter ( index ) {
                this.active = index 
            },
            // 鼠标离开
            MouseOut () {
                this.active = ""
                
            },
            // 点击事件
            itemClick ( index ) {
                if (index == 1) {
                    this.scrollTop()
                } else if ( index == 0 ) {
                    this.shareNews()
                }
            },
            // 分享链接
            shareNews () {
                let shareUrl = window.location.href
                const input = document.createElement('input');
                document.body.appendChild(input);
                input.setAttribute('value', shareUrl );
                input.select();
                if (document.execCommand('copy')) {
                    document.execCommand('copy');
                    this.$message.success("复制成功")
                }
                document.body.removeChild(input);
            },
            // 滚动到顶部
            scrollTop () {
                document.documentElement.scrollTop = 0
            },
            // 获取活动详情
            async getMeetingDetail () {
                let res = await this.$axios.post("/lencon/pc/activity/volunteerDetail", { volun_id: this.volun_id })
                if ( res.data.code == 1 ) {
                    this.info = res.data.obj
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.detail {
    width: 1200px;
    // min-height: 700px;
    margin: 20px auto;
    .box_title {
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        border-left: 4px solid #fff;
        margin: 20px 0;
        .box_title_left {
            font-size: 24px;
            font-weight: bold;
        }
        .box_title_right {
            font-size: 14px;
        }
    }
    .content_box {
        width: 1200px;
        padding: 40px;
        background-color: #fff;
        position: relative;
        left: 0;
        top: 0;
        .fixed_box {
            position: fixed;
            top: 370px;
            left: 200px;
            background-color: #fff;
            width: 100px;
            border-radius: 5px;
            // border: 1px solid #EDEDED;
            overflow: hidden;
            box-shadow:  0 0 4px 5px #eeeeee;
            .item {
                padding: 20px 10px;
                text-align: center;
                cursor: pointer;
                .icon {
                    color: #2767c4 ;
                }
            }
            .active {
                background-color: #2767c4 ;
                color: #ffffff;
                .icon {
                    color: #fff;
                }
            }
        }
        .title {
            text-align: center;
            width: 660px;
            font-size: 30px;
            font-weight: bold;
            margin: 0 auto;
        }
        .desc {
            font-size: 14px;
            margin: 20px 0;
            color: #B6B6B6;
            display: flex;
            align-items: center;
            justify-content: center;
            .item {
                margin: 0 10px;
            }
        }
        .detail {
            width: 100%;
            display: flex;
            img {
                width: 627px;
                height: 376px;
            }
            .info_box {
                margin-left: 20px;
                flex: 1;
                .item {
                    width: 100%;
                    display: flex;
                    font-size: 16px;
                    line-height: 40px;
                    .label {
                        font-weight: bold;
                    }
                    .value {
                        color:#606060;
                        margin-left: 10px;
                        @include MultipleRows(2);
                    }
                }
                .btn_box {
                    display: flex;
                    align-items: center;
                    margin-top: 20px;
                    .btn_item {
                        width: 184px;
                        height: 53px;
                        line-height: 53px;
                        // border: 1px solid #2767c4 ;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 10px;
                        cursor: pointer;
                        border-radius: 5px;
                        span {
                            margin-right: 10px;
                        }
                        .icons {
                            padding-top: 3px;
                        }
                    }
                    .scan_box {
                        background: #FFF4F4;
                        border: 1px solid #2767c4 ;
                        color: #2767c4 ;
                    }
                    .qing_jia {
                        background: #2767c4 ;
                        border: 1px solid #2767c4 ;
                        color: #fff;
                    }
                   
                    .qing_jia {
                        background-color: #2767c4 ;
                        color: #fff;
                    }
                }
            }
        }

        .meeting_title {
            font-size: 24px;
            font-weight: bold;
            line-height: 60px;
            border-bottom: 1px solid #2767c4 ;
            color: #2767c4 ;
        }

        .table_inner {
            margin: 20px 0;
            width: 100%;
            box-sizing: border-box;
            table {
                width: 100%;
                border:1px solid #e2e2e2;
                // border: 1px solid #f5f5f5;
                border-collapse: collapse;
                tr {
                    // display: flex;
                    // align-items: center;
                    td {
                        flex: 1;
                        display: table-cell;
                        text-align: center;
                        height: 80px;
                        vertical-align: middle;
                        font-size: 18px;
                        border:1px solid #e2e2e2;
                    }
                }
            }
        }
        .jiyao_box {
            margin: 20px 0;
        }
        .user_table {
            width: 100%;
            margin: 20px 0;
            table {
                width: 100%;
                border-collapse: collapse;
                tr {
                    width: 100%;
                    th {
                        padding: 10px;
                    }
                    td {
                        padding: 10px;
                        text-align: center;
                        vertical-align: middle;
                    }
                }
            }
        }

        .dialog_box {
            width: 100%;
            height: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 1000;
            background-color: rgba(0,0,0,.3);
            .dialog_content {
                width: 800px;
                height: 600px;
                background-color: #fff;
                position: absolute;
                left: 50%;
                top: 50%;
                margin-left: -400px;
                margin-top: -300px;
                padding: 40px;
                .close_icon {
                    position: absolute;
                    right: 20px;
                    top: 20px;
                    font-size: 30px;;
                }
                .dialog_title {
                    font-size: 24px;
                    color: #2767c4 ;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #2767c4 ;
                    font-weight: bold;
                    .iconfont {
                        font-size: 24px;
                        margin-right: 10px;
                        padding-top: 5px;
                        line-height: 30px;
                    }
                }
                .form_box {
                    padding-top: 20px;
                }
            }
            .qj_status {
                width: 100%;
                text-align: center;
                .icon_box {
                    padding:40px;
                    span {
                        font-size: 120px;
                        
                    }
                    
                }
                .red {
                        color: #2767c4 ;
                    }
                    .gray {
                        color: #b3b3b3;
                    }
                .txt_status {
                    font-size: 24px;
                    font-weight: bold;
                }
                .btn_box {
                    padding-top: 40px;
                    .el-button {
                        width: 145px;
                        height: 45px;
                        border: 1px solid #d0d0d0;
                    }
                }
            }
        }
    }
}
</style>